module.exports = __webpack_public_path__ + "static/media/ndz.4e01e371.svg";